import { render } from "./GoGrassScreenIntro.vue?vue&type=template&id=22474e2e&scoped=true&ts=true"
import script from "./GoGrassScreenIntro.vue?vue&type=script&lang=ts"
export * from "./GoGrassScreenIntro.vue?vue&type=script&lang=ts"

import "./GoGrassScreenIntro.vue?vue&type=style&index=0&id=22474e2e&scoped=true&lang=scss"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22474e2e"]])

export default __exports__